import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";
import { useLang } from "@/contexts/LanguageContext";
import { formatApiError } from "@/contexts/AuthContext";

export default function ForgotPasswordPage() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_token) setDevToken(data.dev_token);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="forgot-page">
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">Reset Password</h1>
      {!sent ? (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-neutral-600">Enter your account email — we'll send you a reset link.</p>
          <input required type="email" className="vt-input" placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          {err && <div className="text-red-600 text-sm">{err}</div>}
          <button disabled={loading} className="vt-btn-orange w-full" data-testid="forgot-submit">{loading ? "..." : "Send Reset Link"}</button>
        </form>
      ) : (
        <div data-testid="forgot-success">
          <p className="mb-6 text-neutral-800">If <strong>{email}</strong> exists in our system, a reset link has been sent.</p>
          {devToken && (
            <div className="border border-neutral-200 p-4 mb-6 bg-yellow-50">
              <div className="overline text-neutral-600 mb-1">Dev Mode (email not configured)</div>
              <p className="text-xs mb-2">Use this link to reset your password:</p>
              <Link to={`/reset-password?token=${devToken}`} className="text-[color:var(--vt-orange)] font-bold text-sm link-underline break-all">
                /reset-password?token={devToken.slice(0, 20)}…
              </Link>
            </div>
          )}
          <Link to="/login" className="vt-btn-outline">Back to Login</Link>
        </div>
      )}
    </div>
  );
}
